module.exports = __webpack_public_path__ + "img/40_52.32a0bf5d.png";